class Tags {
    constructor(element) {
        if (!element) return;

        this.element = element;

        this.init();
    }

    init() {
        this.registerEvents();
    }

    registerEvents() {
        this.element.addEventListener('mouseover', this.toggleIcon.bind(this));
        this.element.addEventListener('mouseout', this.toggleIcon.bind(this));
        this.element.addEventListener('mousemove', this.moveIcon.bind(this));
    }

    toggleIcon() {
        const icon = this.element.querySelector('.tags__image');

        if (!icon) return;

        icon.classList.toggle('is-showing');
    }

    moveIcon(event) {
        const container = event.target;
        const icon = container.querySelector('.tags__image');

        if (!icon) return;

        const rect = container.getBoundingClientRect();

        const clientX = event.clientX - rect.left; // X coordinate relative to the container
        const clientY = event.clientY - rect.top;

        icon.style.top = `${clientY}px`;
        icon.style.left = `${clientX}px`;
    }
}

[...document.querySelectorAll('.tags')].forEach((tags) => {
    for (let index = 0; index < tags.children.length; index++) {
        const element = tags.children[index];
        new Tags(element);
    }
});
